import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import { AuthService } from 'services';

import CloseIcon from '@mui/icons-material/Close';
import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

type ListItemsProps = {
  setPageTitle: Function;
  items: IItem[];
};

interface IItem {
  name: string;
  url: string;
  component: React.ReactNode;
  route: string;
}

export const ListItems = ({ items, setPageTitle }: ListItemsProps) => {
  const { pathname } = useLocation();
  const history = useHistory();

  const handleClick = (url: string, name: string) => {
    setPageTitle(name);
    history.push(url);
  };

  const handleSignOut = () => {
    const role = localStorage.getItem('role');

    history.replace(`/${role}`);
    AuthService.signOut();
  };

  const selected = (route: string) => {
    return pathname.search(route) >= 0;
  };

  return (
    <>
      <List>
        {items.map(({ name, url, component, route }: IItem, index) => (
          <ListItem disablePadding key={String(index)}>
            <ListItemButton
              selected={selected(route)}
              onClick={() => handleClick(url, name)}
            >
              <ListItemIcon>{component}</ListItemIcon>
              <ListItemText primary={name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={handleSignOut}>
            <ListItemIcon>
              <CloseIcon />
            </ListItemIcon>
            <ListItemText primary="Sair" />
          </ListItemButton>
        </ListItem>
      </List>
    </>
  );
};

